import { saveAs } from "file-saver";
import moment from "moment";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import secureStorage from "../../../../services/secureStorage";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import { CLIENT, RESELLER } from "../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../components/main_comps/custom_button";
import CustomDatePicker from "../../../components/main_comps/custom_date_picker";
import CustomSelect from "../../../components/main_comps/custom_select";

const statusOptions = [
  {
    label: "Settled",
    value: "SETTLED",
  },
  {
    label: "Failed",
    value: "FAILED",
  },
];
const DownloadSettlementModal = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [clientName, setClientName] = useState("");
  const [selectedReseller, setSelectedReseller] = useState({
    label: "Select Reseller",
    value: "",
  });
  const [selectedClient, setSelectedClient] = useState({
    label: "Select Client",
    value: "",
  });

  const [loading, setLoading] = useState(false);
  const role = secureStorage.getItem(SS_ROLE);
  const clientOptions = [{ label: "Client Name", value: "" }];
  const [selectedStatus, setSelectedStatus] = useState({
    label: "Select Status",
    value: "",
  });

  const clientList = useSelector((state) => state.dropDownListSlice.clientList);
  const resellerList = useSelector(
    (state) => state.dropDownListSlice.resellerList
  );

  const { enqueueSnackbar } = useSnackbar();

  const onClickDownLoadReport = () => {
    if (fromDate && !toDate) {
      enqueueSnackbar("Please select to date filter", {
        variant: "error",
      });
      return;
    }
    if (
      (fromDate && toDate) ||
      selectedClient.value ||
      selectedReseller.value ||
      Object.keys(selectedStatus).length !== 0
    ) {
      setLoading(true);
      ApiRequestGet.downloadSettlementList({
        userId: selectedClient.value,
        userRefId: selectedReseller.value,
        dateRange:
          fromDate && toDate
            ? moment(fromDate).format("DD/MM/YYYY") +
              "-" +
              moment(toDate).format("DD/MM/YYYY")
            : "",
        status: selectedStatus.value ? selectedStatus.value : "",
      })
        .then((res) => {
          saveAs(res, "settlement.csv");
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      enqueueSnackbar("Please select a filter to download", {
        variant: "error",
      });
    }
  };
  return (
    <div
      style={{
        maxHeight: 500,
        overflow: "scroll",
        position: "relative",
      }}
      className="hide-scroll-bar"
    >
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          From
        </label>
        <CustomDatePicker value={fromDate} onChange={setFromDate} />
      </div>
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          To
        </label>
        <CustomDatePicker
          value={toDate}
          onChange={setToDate}
          minDate={fromDate}
          disabled={fromDate ? false : true}
        />
      </div>

      {role?.toUpperCase() !== CLIENT && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Client
          </label>

          <CustomSelect
            value={selectedClient}
            options={clientList}
            onChange={(data) => {
              setSelectedClient(data);
            }}
            placeholder={"Select client"}
          />
        </div>
      )}

      {role?.toUpperCase() !== CLIENT && role?.toUpperCase() !== RESELLER && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Reseller
          </label>

          <CustomSelect
            value={selectedReseller}
            options={resellerList}
            onChange={(data) => setSelectedReseller(data)}
            placeholder={"Select reseller "}
          />
        </div>
      )}

      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Status
        </label>

        <CustomSelect
          value={selectedStatus}
          options={statusOptions}
          onChange={(data) => setSelectedStatus(data)}
          placeholder={"Status"}
        />
      </div>

      <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
        <CustomButton
          title="Download"
          backgroundColor="#38369C"
          styles={{ width: 150 }}
          onClick={() => {
            onClickDownLoadReport();
          }}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default DownloadSettlementModal;
